"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var securityKeys_1 = require("./securityKeys");
// contains all items in security domain
var securityReducers = {
    securityKeys: securityKeys_1.default
};
exports.default = securityReducers;
